// components
import ErrorDetail from "./Detail";
import ErrorGlobal from "./Global";

export default {
  Global: ErrorGlobal,
  Detail: ErrorDetail,
};
